<template>
  <div class="activity-list-view">
    <div class="activity-list-header">
      <div class="list-col col-book">
        {{ $t('ActivityList.tableHeader.book.label') }}
      </div>
      <div class="list-col col-started">
        {{ $t('ActivityList.tableHeader.started.label') }}
      </div>
      <div class="list-col col-completed">
        {{ $t('ActivityList.tableHeader.completed.label') }}
      </div>
      <div class="list-col col-time">
        {{ $t('ActivityList.tableHeader.time.label') }}
      </div>
    </div>
    <div
      v-for="item in activities"
      :key="item.id"
      class="activity-list-item"
      :class="{ disabled: isUnpublished(item.book) }"
    >
      <div class="list-col col-book">
        <BookItem
          class="col-value"
          :book="item.book"
          :show-level="isActivityGoalEnabled"
          :lazy-load="imgLazyLoad"
        />
      </div>
      <div class="list-col col-started">
        <div class="col-label">
          {{ $t('ActivityList.tableHeader.started.label') }}
        </div>
        <div class="col-value">{{ formateDate(item.startAt) }}</div>
      </div>
      <div class="list-col col-completed">
        <div class="col-label">
          {{ $t('ActivityList.tableHeader.completed.label') }}
        </div>
        <div class="col-value">
          <div v-if="item.completed">
            <div>
              {{ formateDate(item.endAt) }}
            </div>
            <div class="col-description">
              {{
                $t('ActivityList.columnDescription.day.label', {
                  days: item.readingDaysAmount
                })
              }}
            </div>
          </div>
          <div v-else :class="{ 'value-in-progress': !item.completed }">
            {{ round(item.readPercent) }}%
          </div>
        </div>
      </div>
      <div class="list-col col-time">
        <div class="col-label">
          {{ $t('ActivityList.tableHeader.time.label') }}
        </div>
        <div class="col-value">
          <div>{{ getReadTimeLabel(item.readeTime) }}</div>
          <div class="col-description">
            {{
              $t('ActivityList.columnDescription.pages.label', {
                pages: round(item.readPages)
              })
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PublicationsTypesEnum from '@shared/enums/PublicationsTypesEnum';
import Utils from '@/services/utils/Utils';
import BookItem from '@/components/pages/UserActivity/BookItem.vue';

export default {
  name: 'ActivityList',
  components: { BookItem },
  props: {
    activities: {
      type: Array,
      required: true
    },
    imgLazyLoad: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('ContextStore', ['isActivityGoalEnabled'])
  },
  methods: {
    isUnpublished(book) {
      return book?.type === PublicationsTypesEnum.UNPUBLISHED_DEFAULT_BOOK;
    },
    getReadTimeLabel(readMinutes) {
      return this.$t('ActivityList.columnDescription.hours.label', {
        time: Utils.getFormattedMinutes(readMinutes)
      });
    },
    formateDate(timestamp) {
      return Utils.dateFormat(timestamp);
    },
    round(p) {
      return Math.round(p);
    }
  }
};
</script>
